<template lang="pug">
  md-button.md-primary(v-on:click="doPrint") {{$props.text}}
</template>
<script>
  import moment from "moment"
  import ZebraPrinterManager from "@/assets/js/print/ZebraPrinterManager.js";
  export default {
    name: 'stock-tickets-print',
    props: {
      trackingNumber: {
        type: String,
        default: ''
      },
      date: {
        type: String,
        default: ''
      },
      fromCity: {
        type: String,
        default: ''
      },
      toCity: {
        type: String,
        default: ''
      },
      fromAddress: {
        type: String,
        default: ''
      },
      toAddress: {
        type: String,
        default: ''
      },
      seatsNumber: {
        type: Number,
        default: 0
      },
      text: {
        type: String,
        default: 'Печать этикеток'
      },
    },
    components: {ZebraPrinterManager},
    data() {
      return {
        printerReady: false,
        PrinterManager: null,
        currentNumber: 1
      }
    },
    watch: {},
    computed: {
      canPrint() {
        return (
          this.printerReady &&
          this.$props.trackingNumber &&
          this.$props.date &&
          (this.$props.fromCity || this.$props.fromAddress) &&
          (this.$props.toCity || this.$props.toAddress) &&
          this.$props.seatsNumber
        );
      }
    },
    methods: {
      getTemplate(i) {
        return (
          "^CWZ,E:TT0003M_.FNT^FS" +
          "^FO40,45^CI28^AZN,40,40^FD№ груза:^FS" +
          "^FO300,45^CI28^AZN,40,40^FD" + this.$props.trackingNumber +  "^FS" +
          (this.$props.seatsNumber ? "^FO720,45^CI28^AZN,40,40^FD" + i + " из " + this.$props.seatsNumber + "^FS" : '') +

          "^FO40,110^CI28^AZN,40,40^FDДата приема^FS" +
          "^FO40,150^CI28^AZN,40,40^FD" + this.$props.date + "^FS" +

          "^FO40,200^CI28^AZN,40,40^FDОтправление^FS" +
          "^FO40,250^CI28^AZN,40,40^FD" + (this.$props.fromAddress) ? this.$props.fromAddress : this.$props.fromCity + "^FS" +

          "^FO40,350^CI28^AZN,40,40^FDНазначение^FS" +
          "^FO40,400^CI28^AZN,40,40^FD" + (this.$props.toAddress) ? this.$props.toAddress : this.$props.toCity  + "^FS" +

          "^FO19,21^GB853,549,12^FS\n" +
          "^FO19,93^GB848,0,11^FS\n" +
          "^FO437,94^GB0,472,12^FS\n" +
          "^FT556,470^BQN,2,10\n" +
          "^FH\\^FDLA," + this.$props.trackingNumber + "^FS"
        );
      },
      init() {
        this.PrinterManager = new ZebraPrinterManager();
        this.PrinterManager.init((status, message) => {
          this.printerReady = !!status;
          if (!status) this.$store.commit('showSnackbar', [message, 6000]);
          this.$store.commit('showSnackbar', ['Принтер получен с кодом ' + status + ', и сообщенеим: ' + message, 6000]);
        });
      },
      doPrint() {
        this.currentNumber = 1;
        this.print();
      },
      print() {
        
        this.PrinterManager.canPrint((status, message) => {
          console.log(status);
          console.log(message);
        });

        if (!this.PrinterManager || !this.printerReady) {
          this.$store.commit('showSnackbar', ['Ошибка печати. Проверьте подключен ли принтер и все ли данные по грузу заполненны.', 6000]);
        } else {
          this.PrinterManager.setHeader(("\xef\xbb\xbf\n^XA\n" + "^MMT\n" + "^PW886\n" + "^LL0591\n" + "^LS0\n"));
          this.PrinterManager.setFooter("^PQ1,0,1,Y^XZ");

          this.PrinterManager.print(this.getTemplate(this.currentNumber), (status, message) => {

            this.$store.commit('showSnackbar', ['Печать прошла с кодом ' + status + ', и сообщенеим: ' + message, 6000]);

            if (!status) this.$store.commit('showSnackbar', [message, 6000]);
            if (status && parseInt(this.currentNumber) !== parseInt(this.$props.seatsNumber) && parseInt(this.$props.seatsNumber) > 0) {
              this.currentNumber++;
              setTimeout(() => this.print(), 200);
            }
          });

        }
      }
    },
    created() {
      this.$nextTick(() => this.init());
    },
  }
</script>



// WEBPACK FOOTER //
// StockTicketsPrint.vue?a9a76f42